import { AuthService } from '@app/services/auth.service';
import { LoggingConsoleService } from '@app/services/logging-console.service';
import { Component, OnInit } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  constructor(
    private swUpdate: SwUpdate,
    private readonly _auth: AuthService,
    private readonly loggingConsole: LoggingConsoleService
  ) {}

  title = '夏原工業 勤怠管理システム';

  ngOnInit() {
    this.loggingConsole.registerDevToolsHelpers();
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.pipe(
        filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY')
      ).subscribe(() => {
        if (confirm('新しいバージョンが利用可能です。新しいバージョンをロードしますか？')) {
          window.location.reload();
        }
      });
    }
  }
}
